import React from 'react';
import {
  makeStyles,
  shorthands,
} from '@fluentui/react-components';
import UserInfoTab from './UserInfoTab';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('0px'),
  },
});

function ExamplePage() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <UserInfoTab />
    </div>
  );
}

export default ExamplePage;